import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelRussian: KeyLabel[] = [
  {
    code: 4,
    label: 'Ф',
  },
  {
    code: 5,
    label: 'И',
  },
  {
    code: 6,
    label: 'С',
  },
  {
    code: 7,
    label: 'В',
  },
  {
    code: 8,
    label: 'У',
  },
  {
    code: 9,
    label: 'А',
  },
  {
    code: 10,
    label: 'П',
  },
  {
    code: 11,
    label: 'Р',
  },
  {
    code: 12,
    label: 'Ш',
  },
  {
    code: 13,
    label: 'О',
  },
  {
    code: 14,
    label: 'Л',
  },
  {
    code: 15,
    label: 'Д',
  },
  {
    code: 16,
    label: 'Ь',
  },
  {
    code: 17,
    label: 'Т',
  },
  {
    code: 18,
    label: 'Щ',
  },
  {
    code: 19,
    label: 'З',
  },
  {
    code: 20,
    label: 'Й',
  },
  {
    code: 21,
    label: 'К',
  },
  {
    code: 22,
    label: 'Ы',
  },
  {
    code: 23,
    label: 'Е',
  },
  {
    code: 24,
    label: 'Г',
  },
  {
    code: 25,
    label: 'М',
  },
  {
    code: 26,
    label: 'Ц',
  },
  {
    code: 27,
    label: 'Ч',
  },
  {
    code: 28,
    label: 'Н',
  },
  {
    code: 29,
    label: 'Я',
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '№',
        modifiers: MOD.SFT,
      },
      {
        label: '№',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: ';',
        modifiers: MOD.SFT,
      },
      {
        label: ';',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '₽',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 39,
    label: '0',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 45,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 46,
    label: '=',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 47,
    label: 'Х',
  },
  {
    code: 48,
    label: 'Ъ',
  },
  {
    code: 49,
    label: '(backslash)',
    meta: [
      {
        label: '/',
        modifiers: MOD.SFT,
      },
      {
        label: '/',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 51,
    label: 'Ж',
  },
  {
    code: 52,
    label: 'Э',
  },
  {
    code: 53,
    label: 'Ё',
  },
  {
    code: 54,
    label: 'Б',
  },
  {
    code: 55,
    label: 'Ю',
  },
  {
    code: 56,
    label: '.',
    meta: [
      {
        label: ',',
        modifiers: MOD.SFT,
      },
      {
        label: ',',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 542,
    label: '!',
  },
  {
    code: 543,
    label: '"',
  },
  {
    code: 544,
    label: '№',
  },
  {
    code: 545,
    label: ';',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: ':',
  },
  {
    code: 548,
    label: '?',
  },
  {
    code: 549,
    label: '*',
  },
  {
    code: 550,
    label: '(',
  },
  {
    code: 551,
    label: ')',
  },
  {
    code: 557,
    label: '_',
  },
  {
    code: 558,
    label: '+',
  },
  {
    code: 561,
    label: '/',
  },
  {
    code: 568,
    label: ',',
  },
  {
    code: 4638,
    label: '!',
  },
  {
    code: 4639,
    label: '"',
  },
  {
    code: 4640,
    label: '№',
  },
  {
    code: 4641,
    label: ';',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: ':',
  },
  {
    code: 4644,
    label: '?',
  },
  {
    code: 4645,
    label: '*',
  },
  {
    code: 4646,
    label: '(',
  },
  {
    code: 4647,
    label: ')',
  },
  {
    code: 4653,
    label: '_',
  },
  {
    code: 4654,
    label: '+',
  },
  {
    code: 4657,
    label: '/',
  },
  {
    code: 4664,
    label: ',',
  },
  {
    code: 5157,
    label: '₽',
  },
];
